import { TradingStatus } from '../status/trading/Trading';
import { connectTradingSidePanel } from './Trading.connect';

export const ConnectedTradingSidePanel = connectTradingSidePanel(TradingStatus);
ConnectedTradingSidePanel.displayName = 'TradingSidePanel';
